<template>
  <div class="row">
    <div class="col-md-8">
      <h2 class="text-left text-white">Competições<a href="https://arena.rtp.pt/gamersmedia/"><span class="show-all-events">ver todas →</span></a></h2>
      <div class="row event-list">
        <div class="col-md-4 col-single-event" v-if="event !== null && k < 3" v-for="(event,k) in events.data" >
          <router-link :to="{ name: 'event', params: { id: event.id }}">
            <div class="single-event-list" :style="`background-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%),url('`+$urlOrDefault(event.cover_picture,'event-cover')+`');`">
              <h5 class="text-white">{{ event.name }}</h5>
              <div class="event-stripe"></div>
            </div>
          </router-link>

        </div>
      </div>
    </div>
    <div class="col-md-4">
      <h2 class="text-left text-white">Jogos</h2>
      <MatchList amount="7"></MatchList>
    </div>
  </div>
</template>

<script>
import MatchList from "@/components/Match/MatchList";
import EventRepository from "@/api/EventRepository";
export default {
  name: "HomeWidget",
  components: {MatchList},
  data(){
    return {
      events: {}
    }
  },
  created() {
    EventRepository.get().then(response => {
      this.events=response.data;
    });
  }
}
</script>

<style scoped>
.single-event-list,.single-other-events-list {
  height: 330px;
  background-size: cover;
  background-position: center center;
  text-align: left;
  position: relative;
  width: 100%;
}

.col-single-event {
  margin-top: 10px;
}


.single-event-list > h5, .single-other-events-list > h5 {
  position: absolute;
  text-shadow: 2px 2px #000;
  bottom: 5px;
  width: 90%;
  left: 5%;
}

.show-all-events {
  margin-left: 20px;
  padding-left: 15px;
  border-left: 1px solid #3A474E;
  font-size: 12px;
  color: #78838A;
  line-height: 12px;
}
</style>